import { Menu } from "lucide-react";
import CustomIcon from "../CustomIcon";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../../App.css";
import { extractDataFromArray, isEmpty, logoutCookies } from "../../utils/utils&validatation";
// import { useAppContext } from "../../context/appContext";
import { getHostDomainImagesApi, signOutApi } from "../../apis/authService";

const menuOptions = [
    { key: "scan", text: "Scan tickets", path: "/event-scanner/ticket-scanner" },
    { key: "status", text: "Live check-in status", path: "/event-scanner/status" },
    { key: "event-change", text: "Change event", path: "/event-scanner/event-slots" },
    { key: "logout", text: `Logout `, path: "/event-scanner/login" },
];

const MenuPopup = ({ id, open, onClose }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const popupRef = React.useRef();

    React.useEffect(() => {
        if (!open) return;

        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open, onClose]);

    if (!open) return null;

    const filteredMenuOptions = location.pathname === "/event-scanner/event-slots"
        ? menuOptions.filter(option => option.key === "logout")
        : menuOptions;

    const handleLogout = async () => {
        try {
            const res = await signOutApi({ cmd: "signOut" });
            if (extractDataFromArray(res, ["errorCode"], 1) == 0) {
                logoutCookies();
                navigate("/event-scanner/login");
            }
        } catch (err) {
            console.error("Error inside signOutApi =>", err)
        }
    };

    return (
        <div className="popup-menu" ref={popupRef}>
            {filteredMenuOptions.map(({ key, text, path }) => (
                <p
                    className="font-sm m-0 cur-pointer"
                    key={key}
                    style={{
                        padding: "8px 16px",
                        color: key === "logout" ? "#e7000b" : "black",
                        userSelect: "none",
                        fontWeight: location.pathname.includes(path) ? "560" : "",
                        backgroundColor: location.pathname.includes(path) ? "#f3f4f6" : "",
                    }}
                    onClick={() => {
                        if (key === "logout") {
                            // Add logout logic here
                            handleLogout();
                        } else if (key === "status") {
                            navigate(`/event-scanner/status/${id}`);
                        } else if (key === "event-change") {
                            navigate("/event-scanner/event-slots");
                        } else if (key === "scan") {
                            if (location.pathname === `/event-scanner/ticket-scanner/${id}`)
                                window.location.reload();
                            else
                                navigate(`/event-scanner/ticket-scanner/${id}`);
                        }
                        onClose();
                    }}
                    tabIndex={0}
                    onKeyPress={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            onClose();
                        }
                    }}
                    role="menuitem"
                >
                    {text}
                    {key === "logout" ? (
                        <span style={{ color: "#6c757d" }} className="truncated-text">
                            {`(${!isEmpty(extractDataFromArray(window.user_info, ["sub_account_rec"], {})) ? extractDataFromArray(window.user_info, ["sub_account_rec", "name"]).split(" ")[0] : extractDataFromArray(window.user_info, "fname")})`}
                        </span>
                    ) : <span style={{ color: "#6c757d", width: "0" }} className="truncated-text"></span>}
                </p>
            ))}
        </div>

    );
};


const PageHeader = () => {
    const { id } = useParams();
    const location = useLocation();

    const origin = window.location.origin;
    const baseUrl = !origin.endsWith("qrcodechimp.com") && origin;

    const [open, setOpen] = React.useState(false);
    const src = window.logo;

    const toggleMenu = () => setOpen((prev) => !prev);

    React.useEffect(() => {
        const favicon = document.querySelector("link[rel='icon']");
        async function fetchLogo() {
            try {
                const res = await getHostDomainImagesApi({ cmd: "getHostDomainImages" });
                if (extractDataFromArray(res, ["errorCode"], "") === 0) {
                    // const logo = extractDataFromArray(res, ["data", "favicon"], "");
                    // window.logo = baseUrl ? `https:${logo}` : `${location.origin}/assets/images/wallet.ico`;
                    const logo = baseUrl ? extractDataFromArray(res, ["data", "favicon"]) : extractDataFromArray(res, ["data", "wallet_icon"]);
                    window.logo = logo;
                    favicon.href = window.logo;
                } else {
                    // throw error
                }
            } catch (err) {
                console.error("Error fetching host domain images:", err);
            }
        }

        fetchLogo();
    }, [location.hostname]);

    if (location.pathname === "/event-scanner/login") {
        return (
            <div className="flex col-flex items-center text-center bc-white"            >
                <div style={{
                    width: "40px",
                    height: "40px",
                }}>
                    {
                        src &&
                        <CustomIcon
                            id="header-logo"
                            src={src}
                            alt="logo"
                            style={{ marginBottom: "16px", height: "100%", width: "100%" }}
                        />
                    }
                </div>
                <h2 className="mb-4 inherit-bgcolor" style={{
                    height: "28px",
                }}>Event Check-In Portal</h2>
                <p className="mb-12 font-sm" style={{ color: "#6a7282", height: "fit-content", }}>Secure login to scan tickets and manage check-in effortlessly</p>
            </div>
        );
    } else {
        return (
            <div className="header flex g-4 items-center relative"
                style={{
                    height: "49px",
                    padding: "12px 16px",
                }}
            >
                <div style={{
                    width: "40px",
                    height: "40px",
                }}>
                    {
                        src &&
                        <CustomIcon
                            id="header-logo"
                            src={src}
                            alt="logo"
                            style={{ marginBottom: "16px", height: "100%", width: "100%" }}
                        />
                    }
                </div>
                {/* add logic to change the heading as per page */}
                <h2 className="m-0">{location.pathname === `/event-scanner/ticket-scanner/${id}` ? "Ticket Scanner" : location.pathname === "/event-scanner/event-slots" ? `Select Event` : "Live Check-in Status"}</h2>
                <div className="relative" style={{ marginLeft: "auto", }}>
                    <Menu className="cur-pointer" onClick={toggleMenu} />
                    <MenuPopup id={id} open={open} onClose={() => setOpen(false)} />
                </div>
            </div>
        );
    }

};

export default PageHeader;